















const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import YearlyStatusSearch from "@/components/report/YearlyStatusSearch.vue";
import ListView from "@/components/report/YearlyStatusList.vue";
import { GapReportFilter } from "@/store/modules/types";
import App from "@/App.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    YearlyStatusSearch,
    ListView,
  },
  computed: {
    ...mapState("gaps", ["filter"]),
  },
})
export default class YearlyStatusReport extends Vue {
  campaignId: string = "";
  //filter!: this.defaultFilter();
  reportFilter = this.defaultFilter();
  header: any ={};
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.reportFilter =this.defaultFilter(); 
    this.getReport();
  }

  defaultFilter(): GapReportFilter {
    return {
      insurerList: [],
      ipaList: [],
      priorityList: [],
      statusList: [],
      subStatusList: [],
      admissionDischargeList: [],
      providerList:[],
      ownerUserList:[],
      referenceDate: {
        to: null,
        from: null,
      },
      createdDate: {
        to: null,
        from: null,
      },
      updated: {
        to: null,
        from: null,
      },
      apptDate: {
        to: null,
        from: null,
      },
      campaignId: null,
      ipaNumber:"",
    };
  }

  async getReport() {
    this.pageRows = [];
    if(!this.reportFilter.campaignId){return;}

    this.$store.commit("main/SET_LOADING", true);
    const { campaignId, ipaNumber } = this.reportFilter;
    try {
      const data = await this.$store.dispatch(
        "gaps/getYearlyStatusReport",
        this.reportFilter
      );
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getDefaulthCampaign() {
    return this.$store.state.gaps.campaigns[0];
  }

   get getCampaignSelected() {
    return this.$store.state.gaps.campaigns.filter((c) => c.id === this.reportFilter.campaignId)[0];
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  exportExcel() {
    /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
    var reportTitle = "YEARLY STATUS REPORT";
    var subtitle = this.getCampaignSelected.name;
    var fileName =
      "yearly_status_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate = "";
    const medicalOffice = this.getEntity.name;

    const header = Object.keys(this.pageRows[0]);
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const item of this.pageRows) {
      var row: any = [];

      
      for ( const prop in item)
          row.push(item[prop]);

      data.push(row);
    }

    //const totals = this.pageRows.map((i) => i.Total).reduce((accumulator, value) => accumulator + value, 0);

    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("J1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("J2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("J3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("J4").value = reportRangeDate);

    // Set font, size and style in title row.
    worksheet.mergeCells("J1:K1");
    worksheet.mergeCells("J2:K2");
    worksheet.mergeCells("J3:K3");
    worksheet.mergeCells("J4:K4");

    worksheet.getCell("J1").font = font;
    worksheet.getCell("J2").font = font;
    worksheet.getCell("J3").font = font;
    worksheet.getCell("J4").font = font;

    worksheet.getCell("J1").alignment = alignment;
    worksheet.getCell("J2").alignment = alignment;
    worksheet.getCell("J3").alignment = alignment;
    worksheet.getCell("J4").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

     /* worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");*/
      worksheet.addImage(logo, "A1:A4");
      worksheet.mergeCells("A1", "A4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 60;
      worksheet.getColumn(2).width = 16;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 16;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 16;
      worksheet.getColumn(8).width = 16;
      worksheet.getColumn(9).width = 16;
      worksheet.getColumn(10).width = 16;
      worksheet.getColumn(11).width = 16;
      worksheet.getColumn(12).width = 16;
      worksheet.getColumn(13).width = 16;
      worksheet.getColumn(14).width = 16;
      worksheet.getColumn(15).width = 16;
      worksheet.getColumn(16).width = 16;
      worksheet.getColumn(17).width = 16;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);

      

      /*let footerRow = worksheet.addRow(["Totals: " + totals]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });*/

      let footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

  clearFilter() {
    this.reportFilter = this.defaultFilter();
    this.$store.commit("gaps/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    //this.filter = this.defaultFilter();
    this.getReport();
  }
}
